// extracted by mini-css-extract-plugin
export default {"accessRuleCard":"styles_accessRuleCard__3T6aC","details":"styles_details__MnJgK","icon":"styles_icon__JNGy+","img":"styles_img__Lbx1R"};